import React from 'react';
import { SearchIcon, FilterIcon, ShuffleIcon } from 'lucide-react';
export function PokemonSearch({
  searchTerm,
  setSearchTerm,
  selectedType,
  setSelectedType,
  selectedRegion,
  setSelectedRegion,
  showShiny,
  setShowShiny,
  onRandomPokemon
}) {
  const types = ['', 'Normal', 'Fire', 'Water', 'Electric', 'Grass', 'Ice', 'Fighting', 'Poison', 'Ground', 'Flying', 'Psychic', 'Bug', 'Rock', 'Ghost', 'Dragon', 'Dark', 'Steel', 'Fairy'];
  const regions = ['', 'Kanto', 'Johto', 'Hoenn', 'Sinnoh', 'Unova', 'Kalos', 'Alola', 'Galar', 'Paldea'];
  return <div className="mb-6 bg-slate-700/60 rounded-lg p-4 border border-slate-600" data-id="element-308">
      <div className="flex flex-col md:flex-row gap-4" data-id="element-309">
        <div className="flex-1" data-id="element-310">
          <div className="relative" data-id="element-311">
            <input type="text" placeholder="Search Pokémon..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full bg-slate-600 text-white placeholder-gray-400 rounded-lg px-4 py-2 pl-10 border border-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-312" />
            <SearchIcon className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" data-id="element-313" />
          </div>
        </div>
        <div className="flex flex-wrap gap-2" data-id="element-314">
          <div className="relative" data-id="element-315">
            <select value={selectedType} onChange={e => setSelectedType(e.target.value)} className="bg-slate-600 text-white rounded-lg px-8 py-2 border border-slate-500 appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-316">
              <option value="" data-id="element-317">All Types</option>
              {types.filter(type => type).map(type => <option key={type} value={type} data-id="element-318">
                    {type}
                  </option>)}
            </select>
            <FilterIcon className="absolute left-2 top-2.5 h-5 w-5 text-gray-400" data-id="element-319" />
          </div>
          <div className="relative" data-id="element-320">
            <select value={selectedRegion} onChange={e => setSelectedRegion(e.target.value)} className="bg-slate-600 text-white rounded-lg px-8 py-2 border border-slate-500 appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-321">
              <option value="" data-id="element-322">All Regions</option>
              {regions.filter(region => region).map(region => <option key={region} value={region} data-id="element-323">
                    {region}
                  </option>)}
            </select>
            <FilterIcon className="absolute left-2 top-2.5 h-5 w-5 text-gray-400" data-id="element-324" />
          </div>
        </div>
      </div>
      <div className="flex flex-wrap items-center justify-between mt-4" data-id="element-325">
        <div className="flex items-center" data-id="element-326">
          <label className="flex items-center cursor-pointer" data-id="element-327">
            <div className="relative" data-id="element-328">
              <input type="checkbox" checked={showShiny} onChange={() => setShowShiny(!showShiny)} className="sr-only" data-id="element-329" />
              <div className="block bg-slate-600 w-14 h-8 rounded-full border border-slate-500" data-id="element-330"></div>
              <div className={`dot absolute left-1 top-1 bg-white w-6 h-6 rounded-full transition ${showShiny ? 'transform translate-x-6 bg-yellow-400' : ''}`} data-id="element-331"></div>
            </div>
            <span className="ml-3 text-white" data-id="element-332">Show Shiny</span>
          </label>
        </div>
        <button onClick={onRandomPokemon} className="px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg flex items-center transition-colors" data-id="element-333">
          <ShuffleIcon className="mr-2 h-5 w-5" data-id="element-334" />
          Random Pokémon
        </button>
      </div>
    </div>;
}